import { listEvents, EventResponse } from '@goldcast/api/backend';

const actions = {
  loadSeriesEvents({ commit, rootGetters }, seriesId: string) {
    const orgId = rootGetters['org/getCurrentOrgId'];
    commit('setIsFetchingEvents', true);

    return new Promise((resolve, reject) => {
      listEvents({
        queryParams: {
          organization: orgId,
          series: seriesId
        }
      })
        .then(eventsInSeries => {
          const transformedEvents = {};
          (eventsInSeries as EventResponse[]).forEach(event => {
            transformedEvents[event.id] = event;
          });
          commit('setEvents', transformedEvents);
          resolve(eventsInSeries);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit('setIsFetchingEvents', false);
        });
    });
  }
};

export default actions;
